import ShoppingCartContent from './ShoppingCartContent';

export default ShoppingCartContent;
